module.exports = __webpack_public_path__ + "static/assets/b14d70e45d588be5106be4ee696dfa3f.png";